import { useEffect } from "react";
import { Bars } from "@/components/site/Trabajo";
import { useApi, Status } from "./useApi";
import { IABorrador } from "./IA";

export const Dialog = ({ onClose, children, testid }) => {
  useEffect(() => {
    const k = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", k);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", k); document.body.style.overflow = ""; };
  }, [onClose]);
  return (
    <div className="dlg" data-testid={testid} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="box">
        <div className="noprint" style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginBottom: 10 }}>
          <button className="btn btn-sol" onClick={() => window.print()} data-testid="dialog-print-btn">Imprimir / PDF</button>
          <button className="btn" style={{ background: "#1E4F87", color: "#fff" }} onClick={onClose} data-testid="dialog-close-btn">Cerrar</button>
        </div>
        {children}
      </div>
    </div>
  );
};

const SECTIONS = [["Interpretación", "interpretacion"], ["Fortalezas", "fortalezas"], ["Factores a tener en cuenta", "factores"], ["Objetivo general", "objetivo"], ["Plan de trabajo", "plan"], ["Nota de calidad", "notaCalidad"]];

export const FichaAtleta = ({ id, onClose }) => {
  const { data, error } = useApi(`/atletas/${id}`);
  const a = data?.atleta, e = data?.evaluacion || {};
  return (
    <Dialog onClose={onClose} testid="ficha-atleta-dialog">
      {!data ? <Status data={data} error={error} /> : (
        <div data-testid="ficha-atleta">
          <p className="note">CONOCIENDO LA MENTE DEL ATLETA</p>
          <h3 style={{ margin: 0 }} data-testid="ficha-nombre">{a.nombre}</h3>
          <p className="note">Edad: {a.edad || ""} · Grado: {a.grado || ""} · Deporte: {a.deporte} · {data.equipo} · Periodo {e.periodo || ""}{a.menorDeEdad && <> · <span className="badge">menor</span></>} · Consentimiento: {a.consentimiento}</p>
          {e.prioridad && <p data-testid="ficha-prioridad"><span className="badge r">Atención prioritaria</span> <span className="note">señal de seguimiento, no diagnóstico</span></p>}
          <Bars data={e} keys={["P", "E", "R", "M", "A", "GLOBAL", "N", "SALUD", "EST"]} testid="ficha-bars" />
          <IABorrador atletaId={a.id} />
          {SECTIONS.filter(([, k]) => e[k]).map(([t, k]) => (
            <div className="panel" style={{ marginTop: 12 }} key={k} data-testid={`ficha-${k}`}><h4>{t}</h4><p className="pre">{e[k]}</p></div>
          ))}
          {e.fuente?.url && <p><a href={e.fuente.url} target="_blank" rel="noopener noreferrer" style={{ color: "var(--sol-l)" }} data-testid="ficha-fuente-link">Ver documento original en Drive</a></p>}
        </div>
      )}
    </Dialog>
  );
};

export const FichaDocumento = ({ id, onClose }) => {
  const { data: d, error } = useApi(`/documentos/${id}`);
  return (
    <Dialog onClose={onClose} testid="ficha-documento-dialog">
      {!d ? <Status data={d} error={error} /> : (
        <div data-testid="ficha-documento">
          <h3>{d.titulo}</h3>
          <p className="note">{[d.tipo, d.deporte, d.periodo, d.ruta].filter(Boolean).join(" · ")}</p>
          {d.url && <p><a href={d.url} target="_blank" rel="noopener noreferrer" style={{ color: "var(--sol-l)" }} data-testid="documento-drive-link">Abrir en Drive</a></p>}
          <p className="pre">{d.texto || "(sin texto extraído)"}</p>
        </div>
      )}
    </Dialog>
  );
};
